import { get } from 'aws-amplify/api';
import { processResponse } from './api_util';
// import useSWR from 'swr'




export async function getCaseS3Credentials() {

  const payload = {
    apiName: 'LivisiblyCaseS3CredentialsApi',
    path: `credentials`

  }

  const restOperation = get(payload);


  const response = await restOperation.response;

  return processResponse(response)
}

// export function useGetCaseS3Credentials(shouldFetch = true) {
//   const result = useSWR(
//     shouldFetch ? ['CASECREDENTIALS'] : null,
//     (path) => getCaseS3Credentials(),
//     { refreshInterval: 3600000 } // refresh every hour
//   );
//   return result;
// }


